// extracted by mini-css-extract-plugin
export default {"container":"DocumentsViewer_container__QFysr","documentViewer":"DocumentsViewer_documentViewer__R9DRH"};